import { Outlet } from 'react-router-dom';

import { StyledContent, StyledLayout } from './EmptyLayout.styles';

export function EmptyLayout({ children }: any) {
  return (
    <StyledLayout data-test-id="empty-app">
      <StyledContent>{children || <Outlet />}</StyledContent>
    </StyledLayout>
  );
}
